import script from "./PaymentHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentHistory.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentHistory.vue?vue&type=style&index=0&id=1b30f43c&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b30f43c"]])

export default __exports__